import { render, staticRenderFns } from "./WangEditorV5.vue?vue&type=template&id=3b7114ed"
import script from "./WangEditorV5.vue?vue&type=script&lang=js"
export * from "./WangEditorV5.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WangEditorV5.vue?vue&type=style&index=1&id=3b7114ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports